// extracted by mini-css-extract-plugin
export default {"main":"ViewDoctorsWorking_main__lruzb","imageDiv":"ViewDoctorsWorking_imageDiv__JCevr"};